import { of, throwError } from 'rxjs'
import { mergeMap } from 'rxjs/operators'
import Fetch from '../fetch'
import DataHelper from 'framework/helpers/data'
import VoltError from 'VoltError'
import Constants from 'api-constants'
import AuthType from 'framework/helpers/auth'
import ConfigHelper from 'framework/helpers/config'
import { getNagraDeviceType, getNagraHardwareType } from '../helpers/index'

export default class MostWatchedApi extends Fetch {
    fetchMostWatched(limit = 10) {
        const { platform } = ConfigHelper.getInstance().getConfig()

        const accessToken = DataHelper.getInstance().getSecondaryAccessToken()
        if (!accessToken) {
            const error = 'Cannot get most watched due to empty Access Token'
            this.logger.error('MostWatchedApi', error)

            return throwError(
                new VoltError(VoltError.codes.USER_PROFILE_RETRIEVAL_FAILED, {
                    extraLog: error,
                })
            )
        }

        return this.fetch({
            url: `${this._getApiUrl()}/contentdelivery/v1/templateviews/MostWatched?page=0&limit=${limit}`,
            method: 'GET',
            headers: {
                'Content-Type': Constants.httpHeader.ContentType.APPLICATION_JSON,
                Authorization: AuthType.BearerToken(accessToken),
                'accept-language': 'en_GB',
                'Nagra-Device-Type': getNagraDeviceType(platform),
                'Nagra-Target': getNagraHardwareType(platform).HardwareType,
            },
            log: 'NAGRA FETCH MOST WATCHED',
        }).pipe(
            mergeMap((response) => {
                const mostWatchedMetadata = response?.response?.rails?.map(
                    ({ name, layout, sections }) => {
                        const metadata = sections?.[0]?.contents?.map((content, index) => {
                            let ranking = index + 1
                            return {
                                contentId: content.id,
                                thumbnail: `${content?.PromoImages?.[0]}`,
                                isLTCU: content?.isLTCU,
                                format: ranking,
                            }
                        })
                        return { name, layout, metadata }
                    }
                )
                return of(mostWatchedMetadata)
            })
        )
    }

    _getApiUrl() {
        // As this implementation of "nagra" is not as a secondary backend for the authentication,
        // use apiUrl to avoid to add complexity with another URL but for future project with "Nagra" should be reworked
        return this.config.urls.apiUrl
    }
}
